import React, { useState } from "react"

import "./search-input.scss"
import Search from "../../images/icons/wdn-search.png"

const SearchInput = props => {
  const [isFocused, setFocused] = useState(false)

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      props.onKeyDown(e)
    }
  }
  const onFocus = () => {
    setFocused(true)
    props.onFocus()
  }

  const onBlur = () => {
    setFocused(!isFocused)
  }

  const handleOnChange = e => {
    props.onChange(e.target.value, e)
  }

  return (
    <div className="search-input-section">
      <input
        type="text"
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={props.placeholder}
        value={props.value}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        className={`w-100 rounded-border ${props?.error}`}
        id="search"
      />
      <div className="wdn-search-icon">
        <img src={Search} alt="" />
      </div>
    </div>
  )
}

export default SearchInput
